import { defineMessages } from '../define';

export const keywords = defineMessages({
  en: {
    'keywords.title': 'Keywords',
    'keywords.description':
      'Threadline watches every incoming message for these terms and can fire a webhook, send a notification or queue an AI analysis when one matches.',
    'keywords.add': 'Add keyword',

    'keywords.mode.CONTAINS': 'Contains',
    'keywords.mode.EXACT': 'Exact',
    'keywords.mode.REGEX': 'Regex',

    'keywords.column.term': 'Term',
    'keywords.column.match': 'Match',
    'keywords.column.case': 'Case',
    'keywords.column.scope': 'Scope',
    'keywords.column.actions': 'Actions',
    'keywords.column.hits24h': 'Hits 24h',

    'keywords.case.sensitive': 'Sensitive',
    'keywords.case.insensitive': 'Insensitive',
    // English needs the singular; Thai has one form for both.
    'keywords.scope.count.one': '{count} session',
    'keywords.scope.count.other': '{count} sessions',

    'keywords.pause': 'Pause {term}',
    'keywords.activate': 'Activate {term}',
    'keywords.rowActions': 'Actions for {term}',

    'keywords.action.webhook': 'Fire webhooks',
    'keywords.action.webhook.hint': 'Sends a keyword.hit event to every endpoint subscribed to it.',
    'keywords.action.notify': 'Send notifications',
    'keywords.action.notify.hint': 'Runs your notification rules for keyword.hit.',
    'keywords.action.ai': 'Run AI analysis',
    'keywords.action.ai.hint':
      'Queues the message for the configured provider. Off unless you have set one up.',
    'keywords.action.off': '{label} (off)',
    'keywords.action.offState': '{label}: off',

    'keywords.created': 'Keyword created',
    'keywords.updated': 'Keyword updated',
    'keywords.deleted': 'Keyword deleted',
    'keywords.requestFailed':
      'The request could not be completed. Check that the gateway is reachable.',

    'keywords.delete.title': 'Delete “{term}”?',
    'keywords.delete.description': 'Recorded hits for this term go with it.',
    'keywords.delete.confirm': 'Delete keyword',

    'keywords.empty.title': 'No keywords yet',
    'keywords.empty.description':
      'A keyword is a term Threadline looks for in every incoming message — a product name, a complaint word, an order prefix — so you hear about it without reading every chat.',

    'keywords.dialog.createTitle': 'Add keyword',
    'keywords.dialog.editTitle': 'Edit keyword',
    'keywords.dialog.description':
      'Matching runs on the text of inbound messages as they are stored.',
    'keywords.termPlaceholder': 'refund',
    'keywords.field.mode': 'Match mode',
    'keywords.caseSensitive': 'Case sensitive',
    'keywords.caseSensitive.hint': 'Off means “Refund” and “refund” both match.',
    'keywords.sessions': 'Sessions',
    'keywords.sessions.all': 'All sessions, including ones added later',
    'keywords.sessions.none': 'No sessions yet.',
    'keywords.onMatch': 'On a match',
    'keywords.create': 'Create keyword',

    'keywords.regex.title': 'Test the pattern',
    'keywords.regex.sampleLabel': 'Sample text',
    'keywords.regex.sampleDefault': 'Order #10428 — the customer is asking for a refund',
    'keywords.regex.enterPattern': 'Enter a pattern to test it.',
    'keywords.regex.matches': 'Matches',
    'keywords.regex.noMatch': 'No match',
    'keywords.regex.noMatchHint': 'This sample would not trigger the keyword.',
    'keywords.regex.invalid': 'Invalid pattern: {message}',

    'keywords.recent.title': 'Recent hits',
    'keywords.recent.description':
      'The last {count} matches seen while this page has been open.',
    'keywords.recent.empty.title': 'Nothing has matched yet',
    'keywords.recent.empty.description':
      'Matches appear here the moment they happen. Leave the page open to watch them arrive.',
  },
  th: {
    'keywords.title': 'คำสำคัญ',
    'keywords.description':
      'Threadline จะตรวจหาคำเหล่านี้ในทุกข้อความที่เข้ามา และเมื่อพบก็สั่งยิง webhook ส่งการแจ้งเตือน หรือส่งเข้าคิววิเคราะห์ด้วย AI ได้',
    'keywords.add': 'เพิ่มคำสำคัญ',

    'keywords.mode.CONTAINS': 'มีคำนี้อยู่',
    'keywords.mode.EXACT': 'ตรงทั้งหมด',
    'keywords.mode.REGEX': 'Regex',

    'keywords.column.term': 'คำ',
    'keywords.column.match': 'การจับคู่',
    'keywords.column.case': 'ตัวพิมพ์',
    'keywords.column.scope': 'ขอบเขต',
    'keywords.column.actions': 'การทำงาน',
    'keywords.column.hits24h': 'พบใน 24 ชม.',

    'keywords.case.sensitive': 'แยกตัวพิมพ์',
    'keywords.case.insensitive': 'ไม่แยกตัวพิมพ์',
    'keywords.scope.count.one': '{count} เซสชัน',
    'keywords.scope.count.other': '{count} เซสชัน',

    'keywords.pause': 'หยุด {term} ชั่วคราว',
    'keywords.activate': 'เปิดใช้งาน {term}',
    'keywords.rowActions': 'การทำงานสำหรับ {term}',

    'keywords.action.webhook': 'ยิง webhook',
    'keywords.action.webhook.hint': 'ส่งเหตุการณ์ keyword.hit ไปยังทุก endpoint ที่สมัครรับไว้',
    'keywords.action.notify': 'ส่งการแจ้งเตือน',
    'keywords.action.notify.hint': 'เรียกใช้กฎการแจ้งเตือนของคุณสำหรับ keyword.hit',
    'keywords.action.ai': 'วิเคราะห์ด้วย AI',
    'keywords.action.ai.hint':
      'ส่งข้อความเข้าคิวให้ผู้ให้บริการที่ตั้งค่าไว้ ปิดอยู่จนกว่าคุณจะตั้งค่าผู้ให้บริการ',
    'keywords.action.off': '{label} (ปิดอยู่)',
    'keywords.action.offState': '{label}: ปิดอยู่',

    'keywords.created': 'สร้างคำสำคัญแล้ว',
    'keywords.updated': 'อัปเดตคำสำคัญแล้ว',
    'keywords.deleted': 'ลบคำสำคัญแล้ว',
    'keywords.requestFailed': 'ดำเนินการตามคำขอไม่สำเร็จ กรุณาตรวจสอบว่าเกตเวย์เชื่อมต่อได้',

    'keywords.delete.title': 'ลบ “{term}” หรือไม่',
    'keywords.delete.description': 'ประวัติการจับคู่ของคำนี้จะถูกลบไปด้วย',
    'keywords.delete.confirm': 'ลบคำสำคัญ',

    'keywords.empty.title': 'ยังไม่มีคำสำคัญ',
    'keywords.empty.description':
      'คำสำคัญคือคำที่ Threadline คอยมองหาในทุกข้อความที่เข้ามา เช่น ชื่อสินค้า คำร้องเรียน หรือคำนำหน้าเลขที่คำสั่งซื้อ คุณจึงรู้เรื่องได้โดยไม่ต้องไล่อ่านทุกแชท',

    'keywords.dialog.createTitle': 'เพิ่มคำสำคัญ',
    'keywords.dialog.editTitle': 'แก้ไขคำสำคัญ',
    'keywords.dialog.description': 'การจับคู่จะทำกับเนื้อความของข้อความขาเข้าตามที่บันทึกไว้',
    'keywords.termPlaceholder': 'คืนเงิน',
    'keywords.field.mode': 'รูปแบบการจับคู่',
    'keywords.caseSensitive': 'แยกตัวพิมพ์เล็ก-ใหญ่',
    'keywords.caseSensitive.hint': 'หากปิดไว้ ทั้ง “Refund” และ “refund” จะถือว่าตรงกัน',
    'keywords.sessions': 'เซสชัน',
    'keywords.sessions.all': 'ทุกเซสชัน รวมถึงเซสชันที่เพิ่มภายหลัง',
    'keywords.sessions.none': 'ยังไม่มีเซสชัน',
    'keywords.onMatch': 'เมื่อพบคำที่ตรงกัน',
    'keywords.create': 'สร้างคำสำคัญ',

    'keywords.regex.title': 'ทดสอบรูปแบบ',
    'keywords.regex.sampleLabel': 'ข้อความตัวอย่าง',
    'keywords.regex.sampleDefault': 'คำสั่งซื้อ #10428 — ลูกค้าขอคืนเงิน',
    'keywords.regex.enterPattern': 'ใส่รูปแบบเพื่อเริ่มทดสอบ',
    'keywords.regex.matches': 'ตรงกัน',
    'keywords.regex.noMatch': 'ไม่ตรงกัน',
    'keywords.regex.noMatchHint': 'ข้อความตัวอย่างนี้จะไม่ทำให้คำสำคัญทำงาน',
    'keywords.regex.invalid': 'รูปแบบไม่ถูกต้อง: {message}',

    'keywords.recent.title': 'การจับคู่ล่าสุด',
    'keywords.recent.description': 'การจับคู่ {count} รายการล่าสุดที่พบระหว่างที่เปิดหน้านี้ค้างไว้',
    'keywords.recent.empty.title': 'ยังไม่มีข้อความใดตรงกัน',
    'keywords.recent.empty.description':
      'รายการที่ตรงกันจะปรากฏที่นี่ทันทีที่เกิดขึ้น เปิดหน้านี้ค้างไว้เพื่อดูรายการที่เข้ามา',
  },
});
